import { LanguageInfo } from "./LanguageInfo";
import { User } from "./User";

export class StoreState {
  constructor() {
    this.user = new User();
    this.isFirebaseReady=false
    this.isSyncing = false;
  }
  sessionId?: string;
  user?: User;
  isFirebaseReady:Boolean;
  isSyncing:Boolean;
  frontLanguage?:LanguageInfo;
  backLanguage?:LanguageInfo;
}
